"use strict";

var cov_26ioq8m2cf = function () {
  var path = "/Volumes/Github-Projects/gitea-react-toolkit/src/components/repository/crud/FormCheckbox.js";
  var hash = "fcb2da6d2ecdaf7bc4081e8b769d72f693879cfb";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/Volumes/Github-Projects/gitea-react-toolkit/src/components/repository/crud/FormCheckbox.js",
    statementMap: {
      "0": {
        start: {
          line: 15,
          column: 2
        },
        end: {
          line: 30,
          column: 4
        }
      },
      "1": {
        start: {
          line: 33,
          column: 0
        },
        end: {
          line: 46,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "FormCheckbox",
        decl: {
          start: {
            line: 8,
            column: 9
          },
          end: {
            line: 8,
            column: 21
          }
        },
        loc: {
          start: {
            line: 14,
            column: 3
          },
          end: {
            line: 31,
            column: 1
          }
        },
        line: 14
      }
    },
    branchMap: {},
    s: {
      "0": 0,
      "1": 0
    },
    f: {
      "0": 0
    },
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184",
    hash: "fcb2da6d2ecdaf7bc4081e8b769d72f693879cfb"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  return coverage[path] = coverageData;
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function FormCheckbox(_ref) {
  var name = _ref.name,
      label = _ref.label,
      checked = _ref.checked,
      onChange = _ref.onChange,
      disabled = _ref.disabled;
  cov_26ioq8m2cf.f[0]++;
  cov_26ioq8m2cf.s[0]++;
  return /*#__PURE__*/_react.default.createElement(_core.FormControlLabel, {
    label: label,
    control: /*#__PURE__*/_react.default.createElement(_core.Checkbox, {
      color: "primary",
      value: "private",
      defaultChecked: checked,
      disabled: disabled,
      name: name,
      id: name + Math.random(),
      onChange: onChange
    })
  });
}

cov_26ioq8m2cf.s[1]++;
FormCheckbox.propTypes = {
  /** The name/id of the field, must be unique. */
  name: _propTypes.default.string.isRequired,

  /** The label of the field. */
  label: _propTypes.default.string.isRequired,

  /** Prepopulate the default value. */
  checked: _propTypes.default.bool,

  /** The function to propogate changes. */
  onChange: _propTypes.default.func,

  /** Set if this field should be required. */
  required: _propTypes.default.bool,

  /** Set if this field should be disabled. */
  disabled: _propTypes.default.bool
};
var _default = FormCheckbox;
exports.default = _default;